
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online/product",
      function () {
        return require("private-next-pages/online/product/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online/product"])
      });
    }
  